<template>
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      v-if="name === 'apple'"
      d="M12.0547 5.53846C13.138 5.53846 14.4959 4.8061 15.3045 3.82962C16.0369 2.94469 16.5709 1.70884 16.5709 0.472982C16.5709 0.30515 16.5556 0.137317 16.5251 0C15.3198 0.0457724 13.8703 0.808646 13.0006 1.8309C12.3141 2.60903 11.6885 3.82963 11.6885 5.08074C11.6885 5.26383 11.719 5.44692 11.7343 5.50795C11.8106 5.5232 11.9326 5.53846 12.0547 5.53846ZM8.2403 24C9.72028 24 10.3764 23.0083 12.2225 23.0083C14.0992 23.0083 14.5111 23.9695 16.1589 23.9695C17.7762 23.9695 18.8595 22.4743 19.8818 21.0095C21.0261 19.3312 21.499 17.6834 21.5296 17.6071C21.4228 17.5766 18.3255 16.3102 18.3255 12.7552C18.3255 9.67324 20.7667 8.28481 20.904 8.178C19.2867 5.85887 16.8303 5.79784 16.1589 5.79784C14.3433 5.79784 12.8633 6.89638 11.9326 6.89638C10.9256 6.89638 9.59822 5.85887 8.0267 5.85887C5.03624 5.85887 2 8.33058 2 12.9994C2 15.8983 3.12905 18.965 4.51748 20.9485C5.70756 22.6268 6.74507 24 8.2403 24Z"
      fill="var(--fillColor, #ffffff)"
    />
    <template v-if="name === 'google'">
      <path
        d="M22.56 12.25C22.56 11.47 22.49 10.72 22.36 10H12V14.26H17.92C17.66 15.63 16.88 16.79 15.71 17.57V20.34H19.28C21.36 18.42 22.56 15.6 22.56 12.25Z"
        fill="var(--fillColor, #4285F4)"
      />
      <path
        d="M11.9997 23C14.9697 23 17.4597 22.02 19.2797 20.34L15.7097 17.57C14.7297 18.23 13.4797 18.63 11.9997 18.63C9.13969 18.63 6.70969 16.7 5.83969 14.1H2.17969V16.94C3.98969 20.53 7.69969 23 11.9997 23Z"
        fill="var(--fillColor, #34A853)"
      />
      <path
        d="M5.84 14.0899C5.62 13.4299 5.49 12.7299 5.49 11.9999C5.49 11.2699 5.62 10.5699 5.84 9.90995V7.06995H2.18C1.43 8.54995 1 10.2199 1 11.9999C1 13.7799 1.43 15.4499 2.18 16.9299L5.03 14.7099L5.84 14.0899Z"
        fill="var(--fillColor, #FBBC05)"
      />
      <path
        d="M11.9997 5.38C13.6197 5.38 15.0597 5.94 16.2097 7.02L19.3597 3.87C17.4497 2.09 14.9697 1 11.9997 1C7.69969 1 3.98969 3.47 2.17969 7.07L5.83969 9.91C6.70969 7.31 9.13969 5.38 11.9997 5.38Z"
        fill="var(--fillColor, #EA4335)"
      />
    </template>
    <path
      v-else-if="name === 'venmo'"
      d="M19.9315 1C20.6691 2.2 21 3.43738 21 5C21 9.98361 16.6895 16.4557 13.1911 21H5.20277L2 2.0918L8.99692 1.43607L10.698 14.8898C12.2794 12.3443 14.235 8.34426 14.235 5.61902C14.235 4.1259 13.9758 3.11082 13.5705 2.27475L19.9315 1Z"
      fill="var(--fillColor, #ffffff)"
    />
  </svg>
</template>

<script lang="ts" setup>
import type { LogoName } from "./Logo.types";

const {
  name,
} = defineProps<{
  name?: LogoName,
}>();
</script>

<style lang="scss" scoped>
.Logo {
  display: block;

  :deep(path) {
    transition: 350ms fill;
  }
}
</style>
